import React from 'react';
import { StyledInput } from './styled';

const TextInput = ({
  innerRef,
  defaultValue,
  placeholder,
  onKeyPress,
  onChange,
  onClick,
  onBlur,
}) => {
  return (
    <StyledInput
      type='text'
      innerRef={innerRef}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onKeyPress={onKeyPress}
      onChange={onChange}
      onClick={onClick}
      onBlur={onBlur}
    />
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/TextInput/TextInput.jsx